import React, { Fragment, useContext } from 'react';

import './DashboardContainer.scss';
import DashboardPanelProviderCompletionBarStats from "root/Dashboard/DashboardPanelProviderCompletionBarStats";
import DashboardPanelProviderRAGBarStats from "root/Dashboard/DashboardPanelProviderRAGBarStats";
import GlobalContext from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const TeacherDashboardContainer = (props) => {

    const sessionContext = useContext( GlobalContext ) ;

    const survey_type = sessionContext.getCurrentSurveyType() ;

    const dash_title = sessionContext.getCustomObject( ConfigOptions.DASHBOARD_TITLE_COMPLETION ) ;

    const dashboardRows = () => {
        return (
            <Fragment>

                <div key='row1' className='row'>
                    <div className='col-md-12'>
                        <div className='dash-style'>
                            <DashboardPanelProviderCompletionBarStats provider_id={props.provider_id} survey_type={survey_type} title={dash_title} id={1}/>
                        </div>
                    </div>
                </div>
                <div key='row2' className='row'>
                    <div className='col-md-12'>
                        <div className='dash-style'>
                            <DashboardPanelProviderRAGBarStats provider_id={props.provider_id} survey_type={survey_type} title='Completed Questions by RAG Status' id={2}/>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }

    return dashboardRows();
}

export default TeacherDashboardContainer;